module.exports = __webpack_public_path__ + "static/media/icon-cta-plus.ada7eded.svg";